<template>
  <div
    @mouseenter="setToCurrentTabIfAlwaysShow"
    @mouseleave="setToLastTabId"
    ref="bookAreaContainer"
    class="book"
    :class="{ 'mobile-book': $_mobile, 'always-show-book': alwaysShow }"
  >
    <!--     <mefoContainer
      :resize_trigger="$store.state.tabsManager.splitterChange"
      v-show="
        $store.state.bookOnlyMode &&
        $store.state.tabs[$store.state.tabsManager.currentTabId] &&
        $store.state.mefo.showMefoArea &&
        $store.state.tabsManager.currentTabId == tabId &&
        $store.state.tabs[$store.state.tabsManager.currentTabId]
          .SHAS_SECTION_LIST_ID
      "
      :key="tabId"
      :tabId="tabId"
    /> -->
    <LoginPopup
      :mode="loginMode"
      v-if="$store.state.bookOnlyMode && showLogin"
      @closelogin="hideLogin"
    />
    <headersPopup
      :tabId="tabId"
      v-if="$store.state.tabsManager.showHeadersTabId == tabId"
    />
    <template v-if="getCurrentBook > 0">
      <BaseCleanPopup
        v-body
        v-zindex
        :h="40"
        :winh="300"
        :winw="550"
        ref="ocrwin"
        v-if="OCRResultsVisible && showOCREditor"
        @resize="reRenderImage()"
        :showfn="reRenderImage"
        @close="
          toggleOCR({ show: false });
          showOCREditor = false;
        "
        :noneOverlay="true"
        :mini="true"
        :mini_title="$t('bookSelectArea.header')"
      >
        <template v-slot:header>
          <span class="flex flex-align-center h-100">
            {{ $t("bookSelectArea.header") }}
          </span>
        </template>
        <div class="mrg-6 ocr-win-container">
          <div v-if="supportsOcr" class="inner-results ocr-content">
            <div class="ocr-text-container">
              <div class="title-ocr-win flex">
                {{ $t("general.text") }} (OCR):
                <div class="flex">
                  <BaseButton class="textSizeBtn" @click="decTxt">
                    -
                  </BaseButton>

                  <BaseButton class="textSizeBtn" @click="incTxt">
                    +
                  </BaseButton>
                </div>
              </div>
              <textarea
                :style="fontStyle"
                width="200px"
                class="mrg-l-6 ocr-text-area"
                height="200px"
                v-model="OCR"
                ref="textArea"
                v-focus
                @input="updateOcr"
              ></textarea>
            </div>
            <div class="img-ocr" ref="canvasContainer">
              <div class="title-ocr-win">{{ $t("general.img") }} :</div>
              <canvas ref="canvas"></canvas>
            </div>
          </div>
          <div class="buttons flex-bet padd-12">
            <div v-if="supportsOcr">
              <div class="btn btn-outline" @click="copyTxt">
                {{ $t("bookSelectArea.btnCopyTxt") }}
              </div>
            </div>
            <div class="flex-bet">
              <div v-kiosk.remove>
                <BaseButton @click="createMarker">
                  {{ $t("bookSelectArea.btnCrtMarker") }}
                </BaseButton>
              </div>
              <div v-kiosk.remove>
                <BaseButton @click="printCroppedImg">
                  {{ $t("toolbox.print") }}
                </BaseButton>
              </div>
              <div v-kiosk.remove>
                <BaseButton @click="copyImage" v-kiosk>
                  {{ $t("bookSelectArea.btnCopyImg") }}
                </BaseButton>
              </div>
              <BaseButton @click="copyImageToCB">
                {{ $t("bookSelectArea.btnCopyImgCB") }}
              </BaseButton>
            </div>
          </div>
        </div>
      </BaseCleanPopup>

      <!-- </vue-draggable-resizable> -->
      <!-- צייונים, עמודים וציונים אישיים -->

      <Split
        class="flex-g-1 book-gutter-container"
        :class="{ 'tsiyunim-close': !pagesPanelOpen, 'mobile-book': $_mobile }"
        @onDragEnd="onDragEnd"
      >
        <SplitArea
          :class="{ 'full-screen': !pagesPanelOpen }"
          :size="defaultSplitterBook"
          :minSize="200"
        >
          <freeSearchProgress
            class="search-in-book"
            v-if="isSearching"
            :percent="percent"
            :search="fsTxtSearch"
            :seconds="seconds"
            @stop="stopFreeSearch()"
            :message="$t('freeSearchResults.reloadResults')"
          />
          <div class="bookBox">
            <booksHeader
              class="header-book-area padd-t-3"
              :class="{ hide: hideBookHeader, mobilecenter: $_mobile }"
              :book="getCurrentBook"
              :numPages="getPages.filter((p) => !p.empty).length"
              :page="getCurrentPage"
              :tabId="tabId"
              @font-family="changeFontFamily"
              @font-size="changeFontSize"
              @search="setSearching"
            />

            <div
              class="book-area wide-scroll"
              ref="bookArea"
              @click="openEditorPosition($event)"
              :class="dataClass"
            >
              <div class="close-open-dockable" v-if="!$_mobile">
                <div
                  :class="{ fullscreen: hideBookHeader }"
                  class="otz-icon icon-open-dockable"
                  v-show="!pagesPanelOpen"
                  @click="toggleDockable()"
                >
                  <span class="inner-icon"> N </span>
                </div>
                <div
                  class="otz-icon icon-close-dockable"
                  v-show="pagesPanelOpen"
                  @click="toggleDockable()"
                >
                  7
                </div>
              </div>

              <txt-book-area
                v-if="txtBook"
                :tabId="tabId"
                :tabData="getTabData"
                :drawFs="drawFs"
                :fontFamily1="fontF"
                :fontSize1="fontS"
                @print="showPrintWin"
              />

              <bookArea
                @addexten="showEditor = true"
                v-else
                :tabId="tabId"
                :tabData="getTabData"
                @toggleocr="toggleOCR"
                :mm="drawMM"
                :drawFs="drawFs"
                @print="showPrintWin"
                @login="$emit('login')"
                :rotateImage="rotateImage"
              />
              <mefPurchase
                :mefLic="!hasNoMefLic"
                :rambam="isRambamMef"
                v-kiosk.remove
                v-if="
                  isMefoOn &&
                  showMefFeuthures &&
                  !String(tabId).startsWith('win_') &&
                  showMefPurchase
                "
              />
            </div>
          </div>
        </SplitArea>
        <component
          :is="SpliterOrTemplate"
          class="open-dockable border-b-light"
          :class="{ close: !pagesPanelOpen, 'mobile-book-info': $_mobile }"
          :size="defaultSplitterBookInfo"
          :minSize="150"
        >
          <!-- <SplitArea
        v-if="!$_mobile"
        class="open-dockable border-b-light"
        :class="{ close: !openDock }"
        :size="defaultSplitterBookInfo"
        :minSize="130"
      > -->
          <!-- pages and fs results of text book -->

          <div
            class="open-dockable"
            :class="{ 'mobile-book-info-w': $_mobile }"
            v-if="txtBook"
          >
            <div
              class="close-open-dockable"
              :class="{ 'mobile-close-dock-container': $_mobile }"
              v-if="$_mobile"
            >
              <div
                class="otz-icon icon-open-dockable"
                :class="{ 'mobile-button-location': $_mobile }"
                v-show="!openDockMode"
                @click="toggleDockable()"
              >
                N
              </div>
              <div
                class="otz-icon icon-close-dockable"
                :class="{ 'mobile-button-location': $_mobile }"
                v-show="openDockMode"
                @click="toggleDockable()"
              >
                7
              </div>
            </div>
            <BaseDockabaleWindow
              v-show="openDockMobile"
              @click="changeDock"
              dockState="dock"
            >
              <template #content class="list-content">
                <!--  fs results -->

                <bookNavigatingList
                  v-if="getFsResults.length > 0"
                  class="flex-first"
                  dockState="full"
                  showCloseIcon="false"
                  :hasContent="getFsResults.length > 0"
                  :search="false"
                  :open="true"
                  :position="3"
                  @click="setPartOpen"
                >
                  <template #header class="list-header">
                    <div>
                      {{ $t("fsresults.header") }}
                    </div>

                    <div class="icon-circle otz-icon arrow-toggle">o</div>
                  </template>
                  <template #search class="list-header"></template>
                  <template #listContent class="list-container">
                    <div
                      class="wide-scroll flex-wrap flex-center text-book-list"
                      style="width: fit-content; max-width: 100%"
                    >
                      <fsResultsItem
                        class="item-text-book item"
                        @click="
                          goToFSPage({ page: fs.id, id: fs.id });
                          $store.dispatch(`tabs/${tabId}/setPage`, fs.id);
                        "
                        v-for="fs in getFsResults"
                        :key="fs.id + fs.parentTitle"
                        :id="fs.id"
                        :title="fs.parentTitle + ' ' + fs.subTitle"
                        :active="fs.id == currFsPage"
                        :class="{ 'nav-active': fs.id == currFsPage }"
                      />
                    </div>
                  </template>
                </bookNavigatingList>

                <!-- pages -->

                <bookNavigatingList
                  class="flex-first"
                  dockState="full"
                  showCloseIcon="false"
                  :hasContent="getPages.length > 0"
                  :search="true"
                  :open="true"
                  :position="0"
                  :scrollto="getCurrentPage"
                  :book="getCurrentBook"
                >
                  <template #header class="list-header"> </template>
                  <template #search class="list-header">
                    <div>
                      <input
                        v-bind:placeholder="$t('pages.placeholder')"
                        @input="searchInList('pages')"
                        ref="inputPages"
                        class="nav-inputs"
                      />
                      <div
                        v-show="searchTxt['pages'] != ''"
                        class="otz-icon no-bg clear-input"
                        @click="clear($refs.inputPages, 'pages')"
                      >
                        F
                      </div>
                    </div>
                  </template>

                  <template #listContent class="list-container">
                    <emptyListMessage
                      :title="$t('general.noFindResults')"
                      v-if="
                        filteredLists2.mainPages.length == 0 &&
                        getPages.length > 0
                      "
                    />
                    <pageNavigatorItem
                      v-for="page in filteredLists2.mainPages"
                      :class="{
                        'nav-active': page.parentId == currentParent,
                        'nav-visited': isPageVisited(page.position),
                      }"
                      :fakeReact="visitedPages"
                      @click="
                        goToPage({ page: page.id });
                        currentParent = page.parentId;
                        $store.dispatch(`tabs/${tabId}/setPage`, page.id);
                      "
                      :key="page.id + page.parentTitle"
                      :id="page.id"
                      :name="page.parentTitle"
                      :position="page.id"
                      :letter="page.parentTitle"
                      :ref="'txt_main_page_' + page.id"
                    />
                  </template>
                </bookNavigatingList>

                <!-- sub pages -->

                <bookNavigatingList
                  class="flex-first"
                  dockState="full"
                  showCloseIcon="false"
                  :hasContent="getPages.length > 0"
                  :search="true"
                  :open="true"
                  :position="0"
                  :scrollto="getCurrentPage"
                  :book="getCurrentBook"
                >
                  <template #header class="list-header"> </template>
                  <template #search class="list-header">
                    <div>
                      <input
                        v-bind:placeholder="$t('pages.placeholder')"
                        @input="searchInList('tsiyunim')"
                        ref="inputPages"
                        class="nav-inputs"
                      />
                      <div
                        v-show="searchTxt['pages'] != ''"
                        class="otz-icon no-bg clear-input"
                        @click="clear($refs.inputPages, 'tsiyunim')"
                      >
                        F
                      </div>
                    </div>
                  </template>

                  <template #listContent class="list-container">
                    <!--  <emptyListMessage
                    :title="$t('general.noFindResults')"
                    v-if="
                      filteredLists2.subPages.length == 0 && getPages.length > 0
                    "
                  /> -->
                    <pageNavigatorItem
                      :class="{
                        'nav-active': p.id == getCurrentPage,
                        'nav-visited': isPageVisited(p.position),
                      }"
                      :fakeReact="visitedPages"
                      @click="
                        goToPage({ page: p.id });
                        $store.dispatch(`tabs/${tabId}/setPage`, p.id);
                      "
                      v-for="p in filteredLists2.subPages"
                      :key="p.id + p.parentTitle"
                      :id="p.id"
                      :name="p.subTitle"
                      :position="p.id"
                      :letter="p.subTitle"
                      :ref="'txt_sub_page_' + p.id"
                    />
                  </template>
                </bookNavigatingList>
              </template>
            </BaseDockabaleWindow>
          </div>

          <div
            class="open-dockable"
            :class="{ 'mobile-book-info-w': $_mobile }"
            v-if="!txtBook"
          >
            <div
              class="close-open-dockable"
              :class="{ 'mobile-close-dock-container': $_mobile }"
              v-if="$_mobile"
            >
              <div
                class="otz-icon icon-open-dockable"
                :class="{ 'mobile-button-location': $_mobile }"
                v-show="!openDockMode"
                @click="toggleDockable()"
              >
                N
              </div>
              <div
                :class="{ 'mobile-button-location': $_mobile }"
                class="otz-icon icon-close-dockable"
                v-show="openDockMode"
                @click="toggleDockable()"
              >
                7
              </div>
            </div>
            <BaseDockabaleWindow
              v-show="openDockMobile"
              @click="changeDock"
              dockState="dock"
            >
              <template #content class="list-content">
                <bookNavigatingList
                  v-if="getFsResults.length > 0"
                  class="flex-first"
                  dockState="full"
                  showCloseIcon="false"
                  :hasContent="getFsResults.length > 0"
                  :search="false"
                  :open="openStatus(3)"
                  :position="3"
                  @click="setPartOpen"
                  @setActive="goToActiveFSResult"
                  :currentItem="currentFSItem"
                  :itemsCount="getFsResults.length"
                >
                  <template #header class="list-header">
                    <div class="truncate-txt">
                      {{ $t("fsresults.header") }}
                      {{
                        $store.state.tabs[tabId].fsTotal != 0
                          ? "{" + $store.state.tabs[tabId].fsTotal + "}"
                          : ""
                      }}
                    </div>

                    <div class="icon-circle otz-icon arrow-toggle">o</div>
                  </template>
                  <template #search class="list-header"></template>
                  <template #listContent class="list-container">
                    <div class="h-100 flex-column flex-center">
                      <div
                        class="flex-wrap flex-center flex-g-1 align-content-start"
                        style="
                          width: fit-content;
                          max-width: 100%;
                          height: calc(100% - 60px);
                          overflow: auto;
                        "
                      >
                        <fsResultsItem
                          @click="
                            goToFSPage({ page: fs.position, id: fs.id });
                            currentFSItem = index;
                          "
                          v-for="(fs, index) in getFsResults"
                          :key="fs.id + fs.position"
                          :id="fs.position"
                          :title="fs.position"
                          :active="fs.id == currFsPage"
                        />
                      </div>
                    </div>
                  </template>
                </bookNavigatingList>

                <bookNavigatingList
                  v-if="showPagesOldMode && hasTabs"
                  class="flex-first"
                  dockState="full"
                  showCloseIcon="false"
                  :hasContent="getPages.length > 0"
                  :search="true"
                  :open="openStatus(0)"
                  :position="0"
                  :scrollto="getCurrentPage"
                  :book="getCurrentBook"
                  @click="setPartOpen"
                  @setActive="goToActivePage"
                  :currentItem="currentPageItem"
                  :itemsCount="filteredLists.pages.length"
                  :listFocus="pagesListFocus"
                >
                  <template #header class="list-header">
                    <div>{{ $t("pages.header") }}</div>
                    <div class="icon-circle otz-icon arrow-toggle">o</div>
                  </template>
                  <template #search class="list-header">
                    <div>
                      <input
                        v-bind:placeholder="$t('pages.placeholder')"
                        @input="
                          searchInList('pages');
                          $nextTick(() => goToActivePage(0));
                        "
                        ref="inputPages"
                        class="nav-inputs"
                        @keydown="keyDown"
                      />
                      <div
                        v-show="searchTxt['pages'] != ''"
                        class="otz-icon no-bg clear-input"
                        @click="clear($refs.inputPages, 'pages')"
                      >
                        F
                      </div>
                    </div>
                  </template>

                  <template #listContent class="list-container">
                    <headerContainer
                      :book="getCurrentBook"
                      :currentHeaderData="currentHeaderData"
                      :single="true"
                      v-if="showHeader"
                    />
                    <RecycleScroller
                      :buffer="80"
                      style="height: 100%; direction: ltr"
                      :items="filteredLists.pages"
                      :item-size="28"
                      v-slot="{ item, index, active }"
                      ref="pagesScroller"
                      @visible="scrollToPage"
                      class="wide-scroll"
                      :min-item-size="1"
                    >
                      <pageNavigatorItem
                        :class="{
                          'nav-active': item.position == getCurrentPage,
                          'nav-visited': isPageVisited(item.position),
                        }"
                        :fakeReact="visitedPages"
                        @click="
                          goToPage({ page: item.position });
                          currentPageItem = item.position;
                        "
                        @mouseenter="setCurrentHeader"
                        @mouseleave="hideHeader"
                        :id="item.id"
                        :name="item.name"
                        :position="item.originPosition || item.position"
                        :letter="pageLetter(item)"
                        :active="active"
                      />
                    </RecycleScroller>
                    <emptyListMessage
                      :title="$t('general.noFindResults')"
                      v-if="
                        filteredLists.pages.length == 0 && getPages.length > 0
                      "
                    />
                  </template>
                </bookNavigatingList>

                <!-- tsiyuns2 -->
                <bookNavigatingList
                  v-if="hasTabs"
                  :hasContent="hasTsiyunimType2"
                  :search="true"
                  class="flex-second"
                  :open="openStatus(4)"
                  :position="4"
                  @click="setPartOpen"
                  :scrollto="getCurrentPage"
                  :book="getCurrentBook"
                  :listFocus="TsiyunListFocus2"
                  @setActive="goToActiveTsiyun2"
                  :currentItem="currentTsiyunItem2"
                  :itemsCount="filteredLists.tsiyunim2.length"
                >
                  <template #header class="list-header">
                    <div>{{ $t("tsiyunim.header2") }}</div>

                    <div class="icon-circle otz-icon arrow-toggle">o</div>
                  </template>
                  <template #search class="list-header">
                    <div>
                      <input
                        :placeholder="$t('tsiyunim.placeholder')"
                        ref="inputTsiyunim2"
                        class="nav-inputs"
                        @keydown="tsiyunKeyDown2"
                      />
                      <div
                        v-show="searchTxt['tsiyunim2'] != ''"
                        class="otz-icon no-bg clear-input"
                        @click="clear($refs.inputTsiyunim2, 'tsiyunim2')"
                      >
                        F
                      </div>
                    </div>
                  </template>

                  <template #listContent="data" class="list-container">
                    <RecycleScroller
                      class="wide-scroll"
                      :buffer="80"
                      style="height: 100%; direction: ltr"
                      :items="
                        tsiyunimType2.map((t, i) => {
                          return { idx: i, ...t };
                        })
                      "
                      :item-size="28"
                      v-slot="{ item, index, active }"
                      keyField="idx"
                      ref="tsiyunimScroller"
                      @visible="scrollToTsiyun"
                      :emitUpdate="true"
                    >
                      <tsiyunItem
                        @mouseenter="setCurrentHeader"
                        @mouseleave="hideHeader"
                        :name="item.name"
                        v-if="item.type == 2"
                        :class="{
                          'nav-active': item.position == getCurrentPage,
                          'nav-visited': isPageVisited(item.page),
                        }"
                        :fakeReact="visitedPages"
                        :mm="true"
                        @click="
                          goToTsiyunByPageName(item.name);
                          currentTsiyunItem2 = index;
                        "
                        @open-mm="
                          openMareMakom(
                            item.catBook,
                            item.catPage,
                            item.CpageName
                          )
                        "
                        :page="item.position"
                        :id="item.id"
                        :title="item.title"
                        :isUser="false"
                        :currentPage="getCurrentPage"
                        :tabId="tabId"
                        :active="active"
                      />

                      <tsiyunItem
                        v-else
                        @mouseenter="setCurrentHeader"
                        @mouseleave="hideHeader"
                        :name="getPageName(item.page)"
                        :class="{
                          'nav-active':
                            item.page == getCurrentPage ||
                            data.active == item.page,
                          'nav-visited': isPageVisited(item.page),
                        }"
                        :fakeReact="visitedPages"
                        @click="
                          goToTsiyun(item.position);
                          currentTsiyunItem2 = index;
                        "
                        :page="item.position"
                        :id="item.id"
                        :title="item.title"
                        :isUser="false"
                        :currentPage="getCurrentPage"
                        :tabId="tabId"
                        :active="active"
                      />
                    </RecycleScroller>
                  </template>
                </bookNavigatingList>

                <bookNavigatingList
                  v-if="hasTabs"
                  :hasContent="hasTsiyunimType1"
                  :search="true"
                  class="flex-second"
                  :open="openStatus(1)"
                  :position="1"
                  @click="setPartOpen"
                  :scrollto="getCurrentPage"
                  :book="getCurrentBook"
                  :listFocus="TsiyunListFocus"
                  @setActive="goToActiveTsiyun"
                  :currentItem="currentTsiyunItem"
                  :itemsCount="filteredLists.tsiyunim.length"
                >
                  <template #header class="list-header">
                    <div>{{ $t("tsiyunim.header") }}</div>

                    <div class="icon-circle otz-icon arrow-toggle">o</div>
                  </template>
                  <template #search class="list-header">
                    <div>
                      <input
                        :placeholder="$t('tsiyunim.placeholder')"
                        ref="inputTsiyunim"
                        class="nav-inputs"
                        @keydown="tsiyunKeyDown"
                      />
                      <div
                        v-show="searchTxt['tsiyunim'] != ''"
                        class="otz-icon no-bg clear-input"
                        @click="clear($refs.inputTsiyunim, 'tsiyunim')"
                      >
                        F
                      </div>
                    </div>
                  </template>

                  <template #listContent="data" class="list-container">
                    <RecycleScroller
                      class="wide-scroll"
                      :buffer="80"
                      style="height: 100%; direction: ltr"
                      :items="
                        tsiyunimType1.map((t, i) => {
                          return { idx: i, ...t };
                        })
                      "
                      :item-size="28"
                      v-slot="{ item, index, active }"
                      keyField="idx"
                      ref="tsiyunimScroller2"
                      @visible="scrollToTsiyun2"
                      :emitUpdate="true"
                    >
                      <tsiyunItem
                        v-if="item.type == 2"
                        :class="{
                          'nav-active': item.page == getCurrentPage,
                          'nav-visited': isPageVisited(item.page),
                        }"
                        :fakeReact="visitedPages"
                        :mm="true"
                        @click="
                          goToTsiyun(item.page);
                          currentTsiyunItem = index;
                        "
                        @open-mm="
                          openMareMakom(
                            item.catBook,
                            item.catPage,
                            item.CpageName
                          )
                        "
                        :page="
                          getPages[item.page - 1]
                            ? getPages[item.page - 1].position
                            : -1
                        "
                        :id="item.id"
                        :title="item.title"
                        :isUser="false"
                        :currentPage="getCurrentPage"
                        :tabId="tabId"
                        :active="active"
                      />

                      <tsiyunItem
                        v-else
                        @mouseenter="setCurrentHeader"
                        @mouseleave="hideHeader"
                        :name="getPageName(item.page)"
                        :class="{
                          'nav-active':
                            item.page == getCurrentPage ||
                            data.active == item.page,
                          'nav-visited': isPageVisited(item.page),
                        }"
                        :fakeReact="visitedPages"
                        @click="
                          goToTsiyun(
                            getPages[item.page - 1]
                              ? getPages[item.page - 1].position
                              : -1
                          );
                          currentTsiyunItem = index;
                        "
                        :page="
                          getPages[item.page - 1]
                            ? getPages[item.page - 1].position
                            : -1
                        "
                        :id="item.id"
                        :title="item.title"
                        :isUser="false"
                        :currentPage="getCurrentPage"
                        :tabId="tabId"
                        :active="active"
                      />
                    </RecycleScroller>
                  </template>
                </bookNavigatingList>

                <bookNavigatingList
                  :hasContent="true"
                  :search="true"
                  class="flex-third"
                  :open="openStatus(2)"
                  :position="2"
                  @click="setPartOpen"
                  :scrollto="getCurrentPage"
                  :itemsCount="getUserTsiyuns.length"
                >
                  <template #header class="list-header">
                    <userTziyunsHeader
                      v-kiosk
                      :title="$t('tsiyunim.myheader')"
                      :tabId="tabId"
                      v-if="!$_mobile"
                    />

                    <div class="icon-circle otz-icon arrow-toggle">o</div>
                  </template>
                  <template #search class="list-header">
                    <div v-show="getUserTsiyuns.length > 0">
                      <input
                        v-bind:placeholder="$t('tsiyunim.myplaceholder')"
                        @input="searchInList('myTsiyunim')"
                        ref="inputMyTz"
                        class="nav-inputs"
                      />
                      <div
                        v-show="searchTxt['myTsiyunim'] != ''"
                        class="otz-icon no-bg clear-input"
                        @click="clear($refs.inputMyTz, 'myTsiyunim')"
                      >
                        F
                      </div>
                    </div>
                  </template>

                  <template
                    #listContent
                    class="list-container"
                    v-if="!$_mobile"
                  >
                    <userTziyunsInnerEmpty
                      v-kiosk
                      v-if="getUserTsiyuns.length == 0"
                      :tabId="tabId"
                    />
                    <emptyListMessage
                      :title="$t('general.noFindResults')"
                      v-if="
                        filteredLists.userTsiyunim.length == 0 &&
                        getUserTsiyuns.length > 0
                      "
                    />
                    <tsiyunItem
                      :class="{
                        'nav-active': tsiyun.page == getCurrentPage,
                        'nav-visited': isPageVisited(tsiyun.page),
                      }"
                      :fakeReact="visitedPages"
                      @click="goToItemPage(tsiyun)"
                      v-for="tsiyun in filteredLists.userTsiyunim"
                      :key="tsiyun.id + tsiyun.title"
                      :page="tsiyun.position"
                      :id="tsiyun.id"
                      :title="tsiyun.title"
                      :isUser="true"
                      :currentPage="getCurrentPage"
                      :tabId="tabId"
                    />
                  </template>
                </bookNavigatingList>
                <bookNavigatingList
                  v-version.up="21"
                  :style="calculateHeightStyle"
                  :hasContent="true"
                  :search="false"
                  class="flex-third recentPages"
                  :open="openAllRecentPages"
                  :position="5"
                  @click="setPartOpen"
                  :scrollto="getCurrentPage"
                  :itemsCount="getRecentPages.length"
                >
                  <template #header class="list-header">
                    <allRecentPages
                      v-kiosk
                      :title="$t('recentPages.myheader')"
                      :tabId="tabId"
                      v-if="!$_mobile"
                    />

                    <div class="icon-circle otz-icon arrow-toggle">o</div>
                  </template>

                  <template #listContent class="list-header" v-if="!$_mobile">
                    <div
                      class="inner-empty rtl padd-v-12"
                      v-if="getRecentPages.length == 0"
                    >
                      <span>{{ $t("recentPages.myplaceholder") }}</span>
                    </div>
                    <div class="recent-container">
                      <recentPageItem
                        @click="goToItemPage(tsiyun, 'lastpage')"
                        v-for="tsiyun in getRecentPages"
                        :tabId="tabId"
                        :key="tsiyun.id"
                        :position="tsiyun.position"
                        :active="tsiyun.position == getCurrentPage"
                        :sticky="tsiyun.sticky == 1 ? 1 : 0"
                        :letter="
                          tsiyun.title
                            ? tsiyun.title
                            : tsiyun.letter && tsiyun.letter != ''
                            ? tsiyun.letter
                            : tsiyun.position
                        "
                      />
                    </div>
                  </template>
                </bookNavigatingList>
              </template>
            </BaseDockabaleWindow>
          </div>

          <!-- תוספות אישיות: מפתחות, הערות,הדגשות -->
          <!-- </SplitArea> -->
        </component>
      </Split>

      <vue-draggable-resizable
        :x="40"
        :y="37"
        v-zindex.fixed
        :parent="true"
        :resizable="false"
        v-if="showUserAdditionsWin && !txtBook"
        :class-name="dock[1]"
        drag-handle=".drag"
        class="extensions-dock personal-ex-dock"
        :class="{ pinned: hasPin, float1: !hasPin }"
      >
        <BaseDockabaleWindow
          @click="changeDock"
          @close="closeUserExtens"
          @pin="togglePin"
          dockState="dock"
          class="personal-extensions-dock"
          :title="true"
        >
          <template #header class="list-header flex drag">
            <div>{{ $t("personalExtensions.titleHader") }}</div>

            <div
              class="icon-del icon-close icon-circle otz-icon"
              @click="togglePersonalExtVisible"
            >
              F
            </div>
          </template>

          <template #content class="list-content">
            <bookNavigatingList
              class="flex-first comment-dock extens-dock"
              dockState="full"
              :hasContent="getPages.length > 0"
              :search="true"
              :open="extensOpenIndex == 1"
              :position="1"
              @click="setPartOpen1"
            >
              <template #header="{ clicked }" class="list-header">
                <!-- <div>{{ $t("personalExtensions.commentTitle") }}</div> -->
                <userExtensionsHeader
                  :title="$t('personalExtensions.commentTitle')"
                  type="comment"
                  @add-exten="addExtenstions"
                  @click="clicked()"
                />

                <div class="icon-circle otz-icon arrow-toggle">o</div>
              </template>
              <template #search class="list-header">
                <!-- <input
                v-bind:placeholder="$t('comment.placeholder')"
                @input="searchInList('comment')"
              /> -->
                <div>
                  <input
                    v-bind:placeholder="$t('comment.placeholder')"
                    @input="searchInList('comment')"
                    ref="inputComment"
                    class="nav-inputs"
                  />
                  <div
                    v-show="searchTxt['comment'] != ''"
                    class="otz-icon no-bg clear-input"
                    @click="clear($refs.inputComment, 'comment')"
                  >
                    F
                  </div>
                </div>
              </template>

              <template #listContent class="list-container">
                <emptyListMessage
                  :title="$t('general.noFindResults')"
                  v-if="
                    filteredLists.comment.length == 0 &&
                    userCommentsList.length > 0
                  "
                />
                <emptyListMessage
                  type="comment"
                  @add-exten="addExtenstions"
                  :title="$t('personalExtensions.noComments')"
                  v-if="userCommentsList.length == 0"
                />
                <!-- <pageNavigatorItem
                v-for="comment in filteredLists.comment"
                :key="comment.id"
                :item="comment"
                @click="goToPage({ page: comment.pageId })"
              />-->
                <!--  <DynamicScroller
                  :items="filteredLists.comment"
                  :min-item-size="70"
                  style="height:100%;direction:ltr"
                >
                  <template v-slot="{ item, index, active }">
                    <DynamicScrollerItem
                      :item="item"
                      :active="active"
                      :size-dependencies="[item.data]"
                      :data-index="index"
                    >
                      <extensPageItem
                        :tabId="tabId"
                        :item="item"
                        type="comment"
                        @click="goToItemPage(item)"
                      />
                    </DynamicScrollerItem>
                  </template>
                </DynamicScroller> -->
                <extensPageItem
                  :tabId="tabId"
                  v-for="comment in filteredLists.comment"
                  :key="comment.id + comment.data"
                  :item="comment"
                  type="comment"
                  @click="goToItemPage(comment)"
                  :searchTxt="searchTxt.comment"
                />
              </template>
            </bookNavigatingList>
            <!-- מפתחות -->
            <bookNavigatingList
              class="flex-first key-dock extens-dock"
              dockState="full"
              :hasContent="getPages.length > 0"
              :search="true"
              :open="extensOpenIndex == 2"
              :position="2"
              @click="setPartOpen1"
            >
              <template #header class="list-header">
                <!-- <div>{{ $t("personalExtensions.commentTitle") }}</div> -->
                <userExtensionsHeader
                  :title="$t('personalExtensions.keyTitle')"
                  type="key"
                  @add-exten="addExtenstions"
                />

                <div class="icon-circle otz-icon arrow-toggle">o</div>
              </template>
              <template #search class="list-header">
                <!-- <input
                v-bind:placeholder="$t('key.placeholder')"
                @input="searchInList('key')"
              /> -->
                <div>
                  <input
                    v-bind:placeholder="$t('key.placeholder')"
                    @input="searchInList('key')"
                    ref="inputKey"
                    class="nav-inputs"
                  />
                  <div
                    v-show="searchTxt['key'] != ''"
                    class="otz-icon no-bg clear-input"
                    @click="clear($refs.inputKey, 'key')"
                  >
                    F
                  </div>
                </div>
              </template>

              <template #listContent class="list-container">
                <emptyListMessage
                  :title="$t('general.noFindResults')"
                  v-if="filteredLists.key.length == 0 && userKeyList.length > 0"
                />
                <emptyListMessage
                  type="key"
                  @add-exten="addExtenstions"
                  :title="$t('personalExtensions.noKeys')"
                  v-if="userKeyList.length == 0"
                />

                <extensPageItem
                  :tabId="tabId"
                  v-for="key in filteredLists.key"
                  :key="key.id + key.key + key.value"
                  :item="key"
                  type="key"
                  @click="goToItemPage(key)"
                  :searchTxt="searchTxt.key"
                />
              </template>
            </bookNavigatingList>
            <!-- הדגשות -->
            <bookNavigatingList
              class="flex-first marker-dock extens-dock"
              dockState="full"
              :hasContent="getPages.length > 0"
              :search="false"
              :open="extensOpenIndex == 3"
              :position="3"
              @click="setPartOpen1"
            >
              <template #header class="list-header">
                <!-- <div>{{ $t("personalExtensions.commentTitle") }}</div> -->
                <userExtensionsHeader
                  :title="$t('personalExtensions.markerTitle')"
                  type="marker"
                  @add-exten="addExtenstions"
                />

                <div class="icon-circle otz-icon arrow-toggle">o</div>
              </template>
              <!-- <template #search class="list-header">
              <input
                v-bind:placeholder="$t('marker.placeholder')"
                @input="searchInList('key')"
              />
            </template>-->
              <template #listContent class="list-container">
                <!-- <emptyListMessage
                :title="$t('general.noFindResults')"
                v-if="filteredLists.key.length == 0 && userKeyList.length > 0"
              />-->
                <emptyListMessage
                  :title="$t('personalExtensions.noMarkers')"
                  type="marker"
                  @add-exten="addExtenstions"
                  v-if="userMarkersList.length == 0"
                />

                <extensPageItem
                  :tabId="tabId"
                  v-for="marker in filteredLists.marker"
                  :key="marker.id + marker.pageId"
                  :item="marker"
                  type="marker"
                  @click="goToItemPage(marker)"
                />
                <div
                  v-observe-visibility="getMoreMarkers"
                  style="height: 10px"
                ></div>
              </template>
            </bookNavigatingList>

            <!-- קישורים פנימיים -->

            <bookNavigatingList
              v-if="!$store.state.bookOnlyMode"
              class="flex-first marker-dock extens-dock"
              dockState="full"
              :hasContent="getPages.length > 0"
              :search="false"
              :open="extensOpenIndex == 4"
              :position="4"
              @click="setPartOpen1"
            >
              <template #header class="list-header">
                <userExtensionsHeader
                  :title="$t('personalExtensions.LinksTitle')"
                  type="link"
                  @add-exten="addExtenstions"
                />
                <div class="icon-circle otz-icon arrow-toggle">o</div>
              </template>

              <template #listContent class="list-container">
                <emptyListMessage
                  type="link"
                  @add-exten="addExtenstions"
                  :title="$t('personalExtensions.noLinks')"
                  v-if="filteredLists.links && filteredLists.links.length == 0"
                />

                <extensPageItem
                  :tabId="tabId"
                  v-for="link in uniqueFilteredLinks"
                  :key="link.id + '' + link.bookId"
                  :item="link"
                  type="link"
                  @click="(item) => goToItemPage(item, 'link')"
                />
              </template>
            </bookNavigatingList>
          </template>
        </BaseDockabaleWindow>
      </vue-draggable-resizable>
      <div class="tool-box" v-mobile.hide>
        <toolBoxContainer
          @drawMM="setDrawMM"
          :book="getCurrentBook"
          :page="getCurrentPage"
          :showDetails="showDetails"
          :showAdds="showUserAdditionsWin"
          :drawFs="drawFs"
          @book-details="showDetailsWin"
          @print="showPrintWin"
          @ocr="toggleOCR"
          @search="setSearching"
          :tabId="tabId"
          @show-add-win="showAddWindow"
          @drawFs="setDrawFs"
          @rotateImage="rotateImage = !rotateImage"
          :showMefFeuthures="showMefFeuthures"
        />
      </div>

      <BaseCleanPopup
        v-body
        :winh="hPrint"
        :winw="510"
        v-if="showPrint"
        v-zindex
        :h="40"
        @close="closePrintWin"
        :noneOverlay="true"
        :mini="true"
        :mini_title="$t('bookPrint.header')"
      >
        <template v-slot:header>
          <span class="flex flex-align-center h-100">{{
            $t("bookPrint.header")
          }}</span>
        </template>
        <printBook
          :pages="getPages"
          :bookid="getCurrentBook"
          @print="showPrintWin"
          @loading="fitSizePrintWin"
          :page="getCurrentPage"
          :book="getCurrentBook"
          drag-handle=".drag"
          class="print-book"
          :tabId="tabId"
          @close="closePrintWin()"
          :drawFs="drawFs"
          :from="printFrom"
          :to="printTo"
          @printId="setPrintId"
        />
      </BaseCleanPopup>

      <BaseCleanPopup
        v-body
        v-if="openEditor && type != 'marker' && showEditor"
        v-zindex
        @close="closeExtens"
        :h="37"
        :mini_title="miniTitle"
        :mini="true"
        :winh="hUserExtens"
        :winw="wUserExtens"
        :noneOverlay="true"
      >
        <template v-slot:header>
          <div class="flex-center-vh">
            {{
              type == "comment"
                ? $t("comments.comment")
                : type == "link"
                ? $t("links.link")
                : $t("keys.key")
            }}
          </div>
        </template>

        <add-user-exten
          :tabId="tabId"
          v-if="type == 'comment'"
          @close="
            closeEditor();
            showEditor = false;
          "
          :x="getOffset.xPx"
          :y="getOffset.yPx"
          :book="getCurrentBook"
          :page="getPageEditor"
        />
        <add-user-key
          :tabId="tabId"
          @close="
            closeEditor();
            showEditor = false;
          "
          :x="getOffset.xPx"
          :y="getOffset.yPx"
          :book="getCurrentBook"
          :page="getPageEditor"
          v-else-if="type == 'key'"
        />
        <add-user-link
          :tabId="tabId"
          :firstonly="addingLink"
          @close="
            closeExtens();
            showEditor = false;
          "
          :x="getOffset.xPx"
          :y="getOffset.yPx"
          :book="getCurrentBook"
          :page="getPageEditor"
          v-else-if="type == 'link'"
          @gotoitempage="(item) => goToItemPage(item, 'link')"
        />
      </BaseCleanPopup>

      <openBookButton
        v-if="hasTabs & !isBookPage"
        class="open-book-btn"
        :book="getCurrentBook"
        :page="getCurrentPage"
      />

      <BaseCleanPopup
        v-if="bookDetailsVisibility && isBookPage"
        :winh="525"
        :winw="693"
        :h="56"
        @close="closeDetails()"
        class="font larg-win"
        @resize="resizeDetailsImg++"
      >
        <template v-slot:header>
          <span class="flex flex-align-center h-100 font">{{
            $t("bookDetails.header")
          }}</span>
        </template>

        <bookDetails
          :bookid="getCurrentBook"
          class="font"
          :triggerResize="resizeDetailsImg"
        />
      </BaseCleanPopup>
    </template>
    <newTab v-else> </newTab>
  </div>
</template>
<script>
import { mapGetters, mapState, mapActions } from "vuex";
import mefoContainer from "@/components/mefo/mefoContainer.vue";
import headersPopup from "./headersPopup.vue";
import newTab from "./newTab.vue";
import bookArea from "@/components/book/bookArea.vue";
import booksHeader from "@/components/book/booksHeader.vue";
import printBook from "@/components/book/printBook.vue";
import bookDetails from "@/components/book/bookDetails.vue";
import tsiyunItem from "@/components/book/tsiyunItem.vue";
import toolBoxContainer from "@/components/book/toolBoxContainer.vue";
import pageNavigatorItem from "@/components/book/pageNavigatorItem.vue";
import fsResultsItem from "@/components/book/fsResultsItem.vue";
const addUserExten = () => import("./addUserExten.vue");
import addUserKey from "./addUserKey.vue";
import addUserLink from "./addUserLink.vue";
import bookNavigatingList from "@/components/book/bookNavigatingList.vue";
import openBookButton from "@/components/book/openBookButton.vue";
import mefPurchase from "@/components/book/mefPurchase.vue";
import extensPageItem from "@/components/book/extensPageItem.vue";
import userTziyunsInnerEmpty from "@/components/book/userTziyunsInnerEmpty.vue";
import emptyListMessage from "@/components/book/emptyListMessage.vue";
import userTziyunsHeader from "@/components/book/userTziyunsHeader.vue";
import allRecentPages from "@/components/book/allRecentPages.vue";
import recentPageItem from "@/components/book/recentPageItem.vue";
import userExtensionsHeader from "@/components/book/userExtensionsHeader.vue";
import freeSearchProgress from "@/components/listBookArea/freeSearchBarContainer/freeSearchProgress.vue";
import txtBookArea from "@/components/book/txtBookArea.vue";
import { getOCR } from "@/services/bookToolBoxMethods.js";
import config from "@/config/general";
import VueSplit from "vue-split-panel";
import BaseTemplate from "@/components/BaseComponents/BaseTemplate.vue";
import mixBook from "@/mixing/mixBook.js";
import mixInputCharsTranslate from "@/mixing/mixInputCharsTranslate";
import { getImageObject, rambamTiferetBooks } from "@/services/bookData.js";
import { printImage } from "@/services/print.js";
import LoginPopup from "@/components/login/loginPopup.vue";
import winManager from "@/services/book_win";
import headerContainer from "@/components/book/headerContainer.vue";
import { stopPrinting } from "@/services/print.js";
import Vue from "vue";

let moment = require("moment");
export default {
  mixins: [mixBook, mixInputCharsTranslate],
  props: ["tabId"],
  data() {
    return {
      openRecentAnyway: true,
      openREcent: true,
      showHeader: false,
      currentHeaderData: {},
      hideHeaderTimer: null,
      showHeaderTimer: null,
      resizeDetailsImg: 0,
      lastTabId: null,
      timeout: null,
      ocrTextSize: 14,
      showOCREditor: false,
      showEditor: false,
      openDockMobile: true,
      currentPageItem: 0,
      currentTsiyunItem: 0,
      currentTsiyunItem2: 0,
      currentFSItem: 0,
      pagesListFocus: false,
      TsiyunListFocus: false,
      TsiyunListFocus2: false,
      tabData: {},
      searchTxt: {
        pages: "",
        tsiyunim: "",
        myTsiyunim: "",
        comment: "",
        key: "",
        marker: "",
        tsiyunim2: "",
      },
      showUserAdditionsWin: false,

      dock: "float",
      activeItem: [0, 0, 0, 0],
      navigatePartsOpen: [true, true, false, true, true],
      extensOpenIndex: 1,
      offsetEditor: {
        x: 0,
        y: 0,
      },
      currFsPage: 0,
      showDetails: false,
      showPrint: false,
      OCR: "",
      OCRRect: {},
      markerRect: {},
      isSearching: false,
      seconds: 0,
      percent: 0,
      fsTxtSearch: "",
      drawMM: false,
      tempOCRImg: null,
      tempCanvas: null,
      tempCanvasCtx: null,
      lastCrop: null,
      drawFs: true,
      currentParent: 0,
      fontF: "",
      fontS: 4,
      hasPin: false,
      hPrint: 440,
      printFrom: -1,
      printTo: -1,
      bookSet: false,
      rotateImage: false,
      totalMarkers: 0,
      limitMarkers: 5,
      offsetMarkers: 0,
      markers: [],
      manualToggle: false,
      emptyPageTop: 0,
      printId: 0,
      react: 0,
      showMefFeuthures: false,
    };
  },
  components: {
    headersPopup,
    mefoContainer,
    headerContainer,
    LoginPopup,
    openBookButton,
    mefPurchase,
    bookArea,
    tsiyunItem,
    toolBoxContainer,
    pageNavigatorItem,
    extensPageItem,
    booksHeader,
    bookNavigatingList,
    userTziyunsHeader,
    allRecentPages,
    recentPageItem,
    printBook,
    bookDetails,
    userTziyunsInnerEmpty,
    emptyListMessage,
    userExtensionsHeader,
    fsResultsItem,
    addUserExten,
    addUserKey,
    addUserLink,
    freeSearchProgress,
    txtBookArea,
    newTab,
  },
  watch: {
    showUserAdditionsWin: function (val) {
      let mode = !val ? "" : this.hasPin ? "dock" : "float";
      this.setPersonalAdditionsPanelOpen(mode);
    },

    hasMefConnection: function () {
      this.reloadMefSections({
        bookId: this.getCurrentBook,
        tabId: this.tabId,
      });
    },
    getUserPermissions: function () {
      this.reloadMefSections({
        bookId: this.getCurrentBook,
        tabId: this.tabId,
      });
    },
    fullScreen: function (val) {
      this.$nextTick(() => {
        if (!val) {
          if (
            this.userSettings.settings.full_screen_hide_right_bar == 1 &&
            !this.manualToggle
          ) {
            this.toggleDockable(false, false, true);
          }
        } else {
          if (this.userSettings.settings.full_screen_hide_right_bar == 1)
            this.toggleDockable(false, false, false);
        }

        this.$nextTick(() => {
          this.toggleSplitter();
        });
      });
    },
    userMarkersList: function (val) {
      this.markers = val.slice(0, this.offsetMarkers);
    },
    miniChanged: function (val) {
      //   if (!val) {
      if (!this.bookSet) {
        this.bookSet = true;
        winManager.createWinBook(
          this.$store.state.tabs[this.tabId].book,
          this.$store.state.tabs[this.tabId].page,
          null,
          null,
          this.tabId
        );
        /*   }
      } else {
        if (this.bookSet) {
          this.bookSet = false;
          winManager.clearWinBook(this.tabId);

        } */
      }
    },

    searching: function (val) {
      this.isSearching = val && this.inBook;
    },
    finishedFs: function (val) {
      if (val) {
        this.setSearching(false);
        this.$store.state.tabs[this.tabId].fsFinished = false;
      }
    },
    getCurrentBook: function (val, oval) {
      if (
        this.fullScreen &&
        this.userSettings.settings.full_screen_hide_right_bar == 1
      )
        this.toggleDockable(false, false, false);
      this.$nextTick(() => {
        this.toggleSplitter();
      });
      this.$store.state.tabs[this.tabId].scrollInPage = 0;
      this.$store.state.tabs[this.tabId].fsTotal = 0;
      this.$store.state.tabs[this.tabId].zoom = 100;

      this.drawFs = true;
      this.$store.state.tabsManager.scrollToFsResult = true;
      Object.keys(this.searchTxt).forEach((key) => (this.searchTxt[key] = ""));
      this.clearAllInputs();
      this.$store.dispatch(`tabs/${this.tabId}/setCustomTitle`, "");
      globalThis.__v8_wasm_ofs.fclose(oval);

      this.$nextTick(() => {
        this.showMefFeuthures = this.isMefoOn;
      });
    },
    startWithMefo: function (val) {
      this.showMefFeuthures = val;
    },
    getCurrentDrawData: function () {
      this.drawFs = true;
      this.$store.state.tabsManager.scrollToFsResult = true;
    },
    scrollTo: function (newV) {
      if (this.txtBook) this.currFsPage = newV;
    },
    getCurrentPage: function (val) {
      this.scrollToPage();
      this.scrollToTsiyun();
      this.scrollToTsiyun2();
      this.scrollToTxtPage(val);
    },
  },
  computed: {
    ...mapState("freeSearch", ["searching", "inBook"]),
    ...mapGetters("createBook", ["getDrawOcrAction"]),
    ...mapState("bookPopups", ["OCREnabled", "bookDetailsVisibility"]),
    ...mapState("personalAdditionsTabs", ["addingLink"]),
    ...mapGetters("personalAdditionsTabs", ["getPersonalAdditions"]),
    ...mapGetters("tabsManager", ["isWindow", "fullScreen"]),
    ...mapGetters("user", [
      "isIPLimited",
      "hasMefLicense",
      "hasMefConnection",
      "getUserPermissions",
    ]),
    startWithMefo() {
      return this.$store.state.tabs[this.tabId].startWithMefo !== false;
    },
    isMefoOn() {
      return this.$store.getters[`tabs/${this.tabId}/isMefoOn`];
    },
    getNavigatePartsOpen() {
      return (
        this.$store.state.tabs[this.tabId].navigatePartsOpen || [
          true,
          true,
          false,
          true,
          true,
        ]
      );
    },
    showPagesOldMode() {
      let mode = this.userSettings.settings.pagesPanel;
      return mode === false ? false : true;
    },
    personalAdditionsPanelOpen() {
      return this.$store.state.tabs[this.tabId].personalAdditionsPanelOpen;
    },
    bookZoom() {
      return this.$store.state.tabs[this.tabId].zoom;
    },
    pagesPanelOpen() {
      return this.$store.state.tabs[this.tabId].pagesPanelOpen === false
        ? false
        : true;
    },
    openAllRecentPages() {
      return (
        this.getRecentsPagesOpen &&
        this.filteredLists.recentPages.length > 0 &&
        this.openRecentAnyway
      );
    },
    getBook() {
      return this.$store.state.tabs[this.tabId].book;
    },
    maxAllowedPage() {
      if (this.appMode.offline()) return 10000;
      if (globalThis.DEV_CONNECT_USER_TO_FREE_AUTO) return 10000;

      let bookPermission =
        this.$store.getters[`tabs/${this.tabId}/isBookAllowedToUser`];
      if (bookPermission) return 10000;
      return this.$store.getters[`tabs/${this.tabId}/maxFreePages`];
    },
    showLogin() {
      return this.$store.state.user.showLogin;
    },
    loginMode() {
      return this.$store.state.user.showLoginMode;
    },
    hideBookHeader() {
      return (
        this.fullScreen &&
        this.userSettings.settings.full_screen_hide_search_bar &&
        this.userSettings.settings.full_screen_hide_search_bar == "1"
      );
    },
    isRambamMef() {
      return rambamTiferetBooks.includes(parseInt(this.getCurrentBook));
    },
    otzarVer() {
      return this.$store.state.otzar_version;
    },
    showMefPurchase() {
      return (
        //globalThis.SERVER_MODE == "offline" &&
        this.mefShas &&
        (this.hasNoMefLic || (this.isRambamMef && this.otzarVer < 23)) &&
        this.getCurrentPage > this.mefFirstPage &&
        this.getCurrentPage < this.mefLastPage &&
        !globalThis.DEV_CONNECT_USER_TO_MEF_FREE_AUTO
      );
    },
    hasNoMefLic() {
      return !this.hasMefLicense || !this.hasMefConnection;
    },
    mefShas() {
      return this.$store.getters[`tabs/${this.tabId}/isMefShas`];
    },
    mefFirstPage() {
      return this.mefShas ? this.$store.state.tabs[this.tabId].mefFirstPage : 0;
    },
    mefLastPage() {
      return this.mefShas ? this.$store.state.tabs[this.tabId].mefLastPage : 0;
    },
    fontStyle() {
      return "font-size:" + this.ocrTextSize + "px";
    },
    alwaysShow() {
      const activeTab = this.$store.getters[`tabsManager/getActiveTab`];

      //disable for select book tab
      if (!activeTab || !activeTab.book || activeTab.book == "-1") return false;
      return this.$store.state.tabs[this.tabId].alwaysShow;
    },
    miniChanged() {
      return this.$store.state.tabs[this.tabId].minimize;
    },
    ocrMode() {
      return this.userSettings.settings.book_selection_default &&
        this.userSettings.settings.book_selection_default == 1
        ? true
        : false;
    },
    visitedPages() {
      return this.$store.state.books.visitedPages[this.getCurrentBook] || [];
    },
    finishedFs() {
      return this.$store.state.tabs[this.tabId].fsFinished;
    },
    scrollTo() {
      return this.$store.state.tabs[this.tabId].scrollTo;
    },
    openDockMode() {
      if (this.$_mobile) return this.openDockMobile;
      return this.pagesPanelOpen;
    },
    SpliterOrTemplate() {
      if (this.$_mobile) {
        return BaseTemplate;
      }
      return VueSplit.SplitArea;
    },
    txtBook() {
      return this.$store.state.tabs[this.tabId].txtBook;
    },
    supportsOcr() {
      return (
        this.otzarBook.type(this.$store.state.tabs[this.tabId].getBook) !=
        "custom"
      );
    },
    getTabData() {
      let a = this.$store.getters["tabs/" + this.tabId + "/getTabData"];
      let pos = 1;

      return a;
    },
    getFsResults() {
      let react = this.$store.state.tabs[this.tabId].fsChange;
      react = this.$store.state.tabs[this.tabId].book;
      let pos = 1;
      let pages = [...this.getPages];
      // debugger;
      if (pages) {
        pages = pages.map((p, i) => {
          if (p.empty) p.position = 0;
          return p;
        });
        pages.forEach((p) => {
          if (p.position > 0) {
            if (p.originPosition == undefined) p.originPosition = p.position;
            p.position = pos;
            pos++;
          }
        });
      }
      let a = pages.filter((p) => p.words);

      return pages ? pages.filter((p) => p.words) : [];
    },
    getPages() {
      let react = this.$store.state.tabs[this.tabId].pages;

      return this.$store.getters["tabs/" + this.tabId + "/getPages"] || [];
      // return this.getTabData.pages || [];
    },
    getCurrentPage() {
      return this.$store.state.tabs[this.tabId].page;
    },
    getCurrentBook() {
      return this.$store.state.tabs[this.tabId].book.toString();
    },
    getCurrentDrawData() {
      return this.$store.state.tabs[this.tabId].drawData;
    },
    getTsiyunim() {
      return this.$store.getters["tabs/" + this.tabId + "/getTsiyunim"] || [];
      // return this.getTabData.tsiyunim || [];
    },
    getUserTsiyuns() {
      return (
        this.$store.getters["tabs/" + this.tabId + "/getUserTsiyuns"] || []
      );

      // return this.getTabData.usertsiyuns || [];
    },
    calculateHeightStyle() {
      if (this.getRecentPages.length === 0) {
        return "max-height: 34px;";
      } else if (this.getRecentPages.length === 1) {
        return "max-height: 64px;";
      } else if (this.getRecentPages.length === 2) {
        return "max-height: 90px;";
      } else if (this.getRecentPages.length === 3) {
        return "max-height: 118px;";
      } else if (this.getRecentPages.length === 4) {
        return "max-height: 117px;";
      } else {
        return "max-height: 117px;";
      }
    },
    getRecentPages() {
      if (this.$store.getters["tabs/" + this.tabId + "/getRecentPages"]) {
        const arr =
          this.$store.getters["tabs/" + this.tabId + "/getRecentPages"];
        arr.sort((a, b) => b.sticky - a.sticky);
        return arr.slice(0, 5);
      } else {
        return [];
      }
    },
    ...mapState("bookPopups", [
      "printBookVisibility",
      "bookDetailsVisibility",
      "bookDetailsFromListBook",
      "personalExtVisibility",
    ]),
    ...mapGetters("tabsManager", [
      "getTabs",
      "getAllTabs",
      "getMaxShown",
      "getActivePage",
      "getActiveTsiyun",
      "getActiveUserTsiyun",
    ]),
    ...mapGetters("bookPopups", ["getSelectBookDetails"]),
    ...mapGetters("bookPersonalExtensions", [
      "getUserCommentsList",
      "getUserKeysList",
      "getUserMarkersList",
      "getUserLinksList",
      "getOpenEditor",
      "getAddExtensType",
      "crtExtentionsMode",
      "getOffset",
      "getPageEditor",
    ]),

    OCRResultsVisible() {
      return this.$store.state.bookPopups.OCRResultsVisible;
    },
    x() {
      let wWindow = this.$refs.bookAreaContainer.clientWidth;
      let left = wWindow / 2 - 220;
      return left;
    },
    y() {
      // return 5;
      let hHeight = this.$refs.bookAreaContainer.clientHeight;
      let top = hHeight / 2 - 250;
      return top;
    },
    openEditor() {
      return (
        this.$store.getters["personalAdditionsTabs/getOpenEditor"] || false
      );
      // return this.getOpenEditor;
    },
    type() {
      return this.getAddExtensType;
    },
    addExtensType() {
      return this.getAddExtensType;
    },
    dataClass() {
      if (this.crtExtentionsMode) return this.type + "-cursor";
      return "";
    },
    personalAdditions() {
      let adds = this.getPersonalAdditions[this.getBook];
      return adds || { comments: [], keys: [], markers: [], links: [] };
    },
    userCommentsList() {
      return this.personalAdditions.comments || [];
      return this.getUserCommentsList.filter(
        (c) => c.bookId == this.getCurrentBook
      );
    },
    userKeyList() {
      return this.personalAdditions.keys || [];
      return this.getUserKeysList.filter(
        (k) => k.bookId == this.getCurrentBook
      );
    },
    userMarkersList() {
      return this.personalAdditions.markers || [];
      return this.getUserMarkersList.filter(
        (m) => m.bookId == this.getCurrentBook
      );
    },
    userLinksList() {
      return this.personalAdditions.links || [];
      return this.getUserLinksList.filter(
        (l) => l.bookId == this.getCurrentBook
      );
    },
    miniTitle() {
      return (
        this.$t(this.addExtensType + "s." + this.addExtensType) +
        " " +
        this.$t("general.new")
      );
    },
    uniqueFilteredLinks() {
      let unq = [];
      this.filteredLists.links.forEach((l) => {
        if (unq.filter((ul) => ul.linkTo == l.id)[0]) return;
        unq.push(l);
      });
      return unq;
    },
    tsiyunimType1() {
      try {
        let t = this.filteredLists.tsiyunim
          .filter((t) => t.type == 1)

          .map((t) => {
            return {
              ...t,
              position: this.getPageRealPosition(t.page).position,
            };
          });

        return t;
      } catch (ex) {
        return [];
      }
    },
    tsiyunimType2() {
      try {
        let tt = this.filteredLists.tsiyunim2
          .filter((t) => t.type == 2)
          .map((t) => {
            return {
              ...t,
              name: this.getPageName(t.page),
              position: this.getPageRealPosition(t.page).position,
            };
          });

        return tt;
      } catch (ex) {
        return [];
      }
    },
    filteredLists2() {
      let search = this.searchTxt;
      let mainPages = this.getPages.filter((page) => {
        try {
          return (
            page.subId == 0 && smartSearch(page.parentTitle || "", search.pages)
          );
          // (page.parentTitle || "").includes(search.pages) && page.subId == 0
        } catch (ex) {
          console.error(ex);
          return false;
        }
      });
      let subPages = this.getPages.filter((page) => {
        try {
          return (
            (page.subTitle || "").includes(search.tsiyunim) &&
            page.parentId == this.currentParent
          );
        } catch (ex) {
          return false;
        }
      });

      let ret = { mainPages, subPages };
      return ret;
    },

    filteredLists() {
      let search = this.searchTxt;
      let pos = 1;
      let pages = this.getPages.map((p, i) => {
        if (p.empty) p.position = 0;

        return p;
      });

      pages.forEach((p) => {
        if (p.position > 0) {
          if (p.originPosition == undefined) p.originPosition = p.position;
          p.position = pos;
          pos++;
        }
      });

      pages = pages.filter((page) => {
        if (search.pages === "") return page;
        try {
          if (
            !page.pagedata ||
            page.pagedata[0].letter == "" ||
            page.pagedata[0].letter == null
          )
            return page.position.toString().includes(search.pages);
          else return page.pagedata[0].letter.includes(search.pages);
        } catch (ex) {
          console.error(ex.message, ex);
          return false;
        }
      });

      let tsiyunim = this.getTsiyunim.filter((page) => {
        try {
          return page.type == 1 && smartSearch(page.title, search.tsiyunim);
          //return page.title.includes(search.tsiyunim) && page.type == 1;
        } catch (ex) {
          console.error(ex.message, ex);
          return false;
        }
      });
      //.slice(0, 10);
      let tsiyunim2 = this.getTsiyunim.filter((page) => {
        try {
          return page.type == 2 && smartSearch(page.title, search.tsiyunim2);
          //  return page.title.includes(search.tsiyunim2) && page.type == 2;
        } catch (ex) {
          console.error(ex.message, ex);
          return false;
        }
      });

      let userTsiyunim = this.getUserTsiyuns.filter((page) =>
        page.title.includes(search.myTsiyunim)
      );

      let comment = this.userCommentsList.filter((page) =>
        page.data.includes(search.comment)
      );
      let key = this.userKeyList.filter((page) => {
        return page.value.includes(search.key);
      });

      this.totalMarkers = this.userMarkersList.length;
      let marker = this.markers;
      let links = this.userLinksList;
      let recentPages = this.getRecentPages;
      let ret = {
        pages,
        tsiyunim,
        userTsiyunim,
        recentPages,
        comment,
        key,
        marker,
        links,
        tsiyunim2,
      };
      return ret;
    },
    getBookTabs() {
      let tabs = this.getTabs;
      return tabs;
    },
    hasTabs() {
      return this.getAllTabs.length > 0;
    },
    hasTsiyunim() {
      let tsiyunim = this.getTsiyunim;
      return tsiyunim.length > 0;
    },
    hasTsiyunimType1() {
      let tsiyunim = this.getTsiyunim.filter((t) => t.type == 1);
      return tsiyunim.length > 0;
    },
    hasTsiyunimType2() {
      let tsiyunim = this.getTsiyunim.filter((t) => t.type == 2);
      return tsiyunim.length > 0;
    },
    isBookPage() {
      return this.$route.name == "bookOnly";
    },
    wUserExtens() {
      // return this.type == "comment" ? 380 : 240;

      switch (this.type) {
        case "comment":
          return 380;
          break;
        case "key":
          return 240;
          break;
        case "link":
          return 380;
          break;
      }
    },
    hUserExtens() {
      // return this.type == "comment" ? 330 : 240;
      switch (this.type) {
        case "comment":
          return 330;
          break;
        case "key":
          return 240;
          break;
        case "link":
          return 280;
          break;
      }
    },
    defaultSplitterBook() {
      if (this.$_mobile) return 100;
      return 100 - this.defaultSplitterBookInfo;
    },
    defaultSplitterBookInfo() {
      //why different  value for window?
      /*  if (this.isWindow(this.tabId)) {
        return 25;
      } */
      let wWindow = window.winSizes.innerWidth;
      let wList;

      return (wList = (250 / wWindow) * 100);
    },
    getRecentsPagesOpen() {
      let x = this.react;
      return localStorage.getItem("recPages") === "false" ? false : true;
    },
  },
  methods: {
    scrollToTxtPage(p) {
      const pageElem = this.$refs["txt_main_page_" + p];
      if (pageElem && pageElem[0]) {
        pageElem[0].$el.scrollIntoViewIfNeeded({ behavior: "smooth" });
        pageElem[0].$el.click();
      }

      const subpageElem = this.$refs["txt_sub_page_" + p];
      if (subpageElem && subpageElem[0])
        subpageElem[0].$el.scrollIntoViewIfNeeded({ behavior: "smooth" });
    },

    setPagesPanel(val) {
      Vue.set(this.$store.state.tabs[this.tabId], "pagesPanelOpen", val);
    },
    togglePagesPanel() {
      let currVal = this.$store.state.tabs[this.tabId].pagesPanelOpen;
      if (this.$store.state.tabs[this.tabId].pagesPanelOpen === undefined)
        Vue.set(this.$store.state.tabs[this.tabId], "pagesPanelOpen", true);

      this.$store.state.tabs[this.tabId].pagesPanelOpen =
        !this.$store.state.tabs[this.tabId].pagesPanelOpen;

      if (this.$_mobile) {
        this.openDockMobile = this.$store.state.tabs[this.tabId].pagesPanelOpen;
      }
    },

    setPrintId(printId) {
      this.printId = printId;
    },
    updateOcr(e) {
      this.OCR = e.target.value;
    },
    getPageName(position) {
      if (this.getPages.length > 0) {
        if (this.getPages[position - 1] != undefined)
          return this.getPages[position - 1].name;
        else return "";
      }
      return "";
    },
    getPageRealPosition(position) {
      return this.getPages[position - 1] || { position: -1 };

      /*       if (this.getPages.length > 0) {
        if (this.getPages[position - 1] != undefined)
          return this.getPages[position - 1].position;
        else return -1;
      }
      return -1; */
    },
    setCurrentHeader(data) {
      if (this.$_mobile) return;
      if (data.pos > this.maxAllowedPage) return;
      clearTimeout(this.hideHeaderTimer);
      clearTimeout(this.showHeaderTimer);
      let timeout = this.showHeader ? 100 : 600;

      this.showHeaderTimer = setTimeout(() => {
        this.currentHeaderData = data;
        this.showHeader = true;
      }, timeout);
    },
    hideHeader() {
      if (this.$_mobile) return;
      clearTimeout(this.showHeaderTimer);
      this.hideHeaderTimer = setTimeout(() => {
        this.showHeader = false;
      }, 300);
    },
    setToLastTabId() {
      if (this.lastTabId) this.setCurrentTabId(this.lastTabId);
    },
    setToCurrentTabIfAlwaysShow() {
      const isAlwaysShow = this.$store.state.tabs[this.tabId].alwaysShow;
      if (isAlwaysShow) {
        //save lastone
        this.lastTabId = this.$store.state.tabsManager.currentTabId;
        //set to current
        this.setCurrentTabId(this.tabId);
      }
    },
    hideLogin() {
      this.$store.state.user.showLogin = false;
    },
    getMoreMarkers(visible) {
      if (!visible) return;
      if (this.offsetMarkers >= this.totalMarkers) return;

      this.offsetMarkers += this.limitMarkers;
      this.markers = this.userMarkersList.slice(0, this.offsetMarkers);
    },
    incTxt() {
      this.ocrTextSize += 1;
    },
    decTxt() {
      this.ocrTextSize -= 1;
    },
    isPageVisited(page) {
      return this.visitedPages.includes(page);
    },
    scrollToPage() {
      if (!this.$refs.pagesScroller) return;
      if (!isInViewport(this.$refs.pagesScroller.$el)) return;
      const pageElem = this.$el.querySelectorAll(
        '.page-nav-item[position="' + this.getCurrentPage + '"][active=true]'
      );

      if (pageElem.length > 0)
        pageElem[0].scrollIntoViewIfNeeded({ behavior: "smooth" });
      else {
        this.$refs.pagesScroller.scrollToItem(this.getCurrentPage - 1);
        /*
        let a = document.getElementsByClassName(
          "vue-recycle-scroller wide-scroll ready direction-vertical"
        ); */

        /*    var arr = Array.prototype.slice.call(a, 0);
        arr.forEach((element) => {
          element.scrollTop = 2000;
          console.log(
            element.className,
            element.scrollTop,
            (this.getCurrentPage - 1) * 28
          );
        }); */

        /*   setTimeout(
          () => this.$refs.pagesScroller.scrollToItem(this.getCurrentPage - 1),
          0
        ); */
        // this.$refs.pagesScroller.scrollToItem(20);
      }
    },
    /*     tsiUpdate(startIndex, endIndex) {
      if (false && this.searchTxt.tsiyunim != "") {
        this.goToActiveTsiyun(startIndex);
      }
    },
    tsi2Update(startIndex, endIndex) {
      if (false && this.searchTxt.tsiyunim2 != "") {
        this.goToActiveTsiyun2(startIndex);
      }
    }, */
    scrollToTsiyun() {
      if (!this.$refs.tsiyunimScroller) return;
      if (!isInViewport(this.$refs.tsiyunimScroller.$el)) return;
      const pageElem = this.$refs.tsiyunimScroller.$el.querySelectorAll(
        '.tsiyun-item[position="' +
          this.getCurrentPage +
          '"][user="1"][active=true]'
      );

      if (pageElem.length > 0)
        pageElem[0].scrollIntoViewIfNeeded({ behavior: "smooth" });
      else {
        let inx = this.tsiyunimType2.findIndex(
          (element) => element.position == this.getCurrentPage
        );
        if (inx >= 0) this.$refs.tsiyunimScroller.scrollToItem(inx);
      }
    },
    scrollToTsiyun2() {
      if (!this.$refs.tsiyunimScroller2) return;
      if (!isInViewport(this.$refs.tsiyunimScroller2.$el)) return;

      const pageElem = this.$refs.tsiyunimScroller2.$el.querySelectorAll(
        '.tsiyun-item[position="' +
          this.getCurrentPage +
          '"][user="1"][active=true]'
      );

      if (pageElem.length > 0)
        pageElem[0].scrollIntoViewIfNeeded({ behavior: "smooth" });
      else {
        let inx = this.tsiyunimType1.findIndex(
          (element) => element.position == this.getCurrentPage
        );
        if (inx >= 0) this.$refs.tsiyunimScroller2.scrollToItem(inx);
      }
    },
    keyDown(event) {
      switch (event.code) {
        case "ArrowDown":
          this.inputDown();

          break;
      }
    },
    tsiyunKeyDown(event) {
      if (!this.isSpecialKeys(event)) {
        this.handleKeydown(event, this.$refs.inputTsiyunim);
      }
      switch (event.code) {
        case "ArrowDown":
          this.inputDownTsiyunim();

          break;
      }
      this.searchInList("tsiyunim");
      this.$nextTick(() => this.goToActiveTsiyun(0));
    },
    tsiyunKeyDown2(event) {
      if (!this.isSpecialKeys(event)) {
        this.handleKeydown(event, this.$refs.inputTsiyunim2);
      }
      switch (event.code) {
        case "ArrowDown":
          this.inputDownTsiyunim2();

          break;
      }
      this.searchInList("tsiyunim2");
      this.$nextTick(() => this.goToActiveTsiyun2(0));
    },
    ...mapActions("bookPopups", [
      "setOCREnable",
      "closePersonalExt",
      "togglePersonalExtVisible",
    ]),
    ...mapActions("tabsManager", [
      "setCurrentScrollTo",
      "setActiveTsiyun",
      "setCurrentTabId",
      "setActivePage",
      "setActiveUserTsiyun",
      "setResizeToggle",
      "toggleSplitter",
      "reloadMefSections",
      "toggleFullScreen",
    ]),
    ...mapActions("bookPersonalExtensions", [
      // "closeEditorWin",
      "startCreateExtentionMode",
      "stopCreatModeAllExtantions",
      "setAddEtensType",
      "closeExtens",
    ]),
    ...mapActions("personalAdditionsTabs", ["closeEditorWin"]),
    ...mapActions("createBook", ["setOcrOutput"]),
    printPage() {
      alert("P");
    },
    clearAllInputs() {
      let inputs = document.getElementsByClassName("nav-inputs");
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].value = "";
      }
    },
    inputDown() {
      this.currentPageItem = 0;
      this.goToActivePage(this.currentPageItem);
      this.pagesListFocus = !this.pagesListFocus;
    },
    inputDownTsiyunim() {
      this.currentTsiyunItem = 0;
      this.goToActiveTsiyun(this.currentTsiyunItem);
      this.TsiyunListFocus = !this.TsiyunListFocus;
    },
    inputDownTsiyunim2() {
      this.currentTsiyunItem2 = 0;
      this.goToActiveTsiyun2(this.currentTsiyunItem2);
      this.TsiyunListFocus2 = !this.TsiyunListFocus2;
    },

    setDrawFs(value) {
      this.drawFs = value;
    },
    showAddWindow(value) {
      value == undefined
        ? (this.showUserAdditionsWin = !this.showUserAdditionsWin)
        : (this.showUserAdditionsWin = value);
    },
    showMarkersList() {
      this.showUserAdditionsWin = true;
      this.$nextTick(() => (this.extensOpenIndex = 3));
    },
    setDrawMM(draw) {
      this.drawMM = draw;
    },

    setSearching({ show, txt }) {
      if (show) {
        this.fsTxtSearch = txt;
        this.interval = setInterval(() => {
          this.seconds += 0.1;
          this.percent += 5;
          if (this.percent > 100) {
            this.percent = 0;
          }
        }, 100);
      } else {
        this.seconds = 0;
        this.percent = 0;
        clearInterval(this.interval);
      }
      this.isSearching = show;
    },
    stopFreeSearch() {
      this.setSearching(false);
    },
    reRenderImage() {
      this.$refs.ocrwin.$el.click();
      if (!this.lastCrop) return;
      this.$nextTick(() => {
        this.drawImgCrop(
          this.lastCrop.img,
          this.lastCrop.cWidth,
          this.lastCrop.cHeight,
          this.lastCrop.startX,
          this.lastCrop.startY,
          this.lastCrop.imgRatio
        );
      });
    },
    zoomInOut(dir) {
      let maxZoom = 250,
        minZoom = 40;

      let zoomValue = this.$store.state.tabs[this.tabId]?.zoom || 100;
      let zoom = zoomValue + 10 * dir;
      if (zoom > maxZoom) zoom = maxZoom;
      else if (zoom < minZoom) zoom = minZoom;
      this.$store.state.tabs[this.tabId].zoom = zoom;
    },
    toggleOCR({
      show,
      img,
      x,
      y,
      width,
      height,
      pageData,
      cWidth,
      cHeight,
      startX,
      startY,
      imgRatio,
      markerRect,
      ocrRectInPx,
      zoomMode,
    }) {
      if (zoomMode) {
        this.zoomInOut(1);
        const _this = this;
        setTimeout(() => {
          _this.$store.state.tabs[this.tabId].scrollPageToXY = {
            x: startX,
            y: startY,
          };
        }, 500);
        // this.$store.state.tabs[this.tabId].zoomMode = false;
        return;
      }
      if (!show) {
        this.tempCanvasCtx.fillStyle = "white";
        this.tempCanvasCtx.fillRect(
          0,
          0,
          this.tempCanvas.width,
          this.tempCanvas.height
        );
      }
      this.lastCrop = {
        img,
        cWidth,
        cHeight,
        startX,
        startY,
        imgRatio,
      };
      this.showOCREditor = true;
      this.OCR = "";
      this.OCRRect = { x, y, width, height, pageData };
      this.markerRect = markerRect;
      if (!this.getDrawOcrAction)
        this.$store.state.bookPopups.OCRResultsVisible = show;
      this.setOCREnable(this.ocrMode);
      if (show) {
        //set rect of drawed part
        this.$store.dispatch(`tabs/${this.tabId}/setRects`, {
          page: this.OCRRect.pageData.position,
          rect: { x, y, width, height },
        });

        if (!this.supportsOcr) return;
        getOCR({
          bookId: this.getCurrentBook,
          pageId: this.OCRRect.pageData.id,
          x: ocrRectInPx.x,
          y: ocrRectInPx.y,
          width: ocrRectInPx.width,
          height: ocrRectInPx.height,
          startWord: pageData.pagedata[0]?.firstWord || 0,
          numWord: pageData.pagedata[0]?.numWords || 0,
          pageData: pageData.pagedata[0],
          positions: false,
          search: [],
        }).then((ocr) => {
          if (Number.isInteger(ocr.data)) {
            this.OCR =
              this.$t("general.noFindResults") +
              ", " +
              this.$t("errors.code") +
              ": " +
              ocr.data;
          } else if (ocr.data === "NA")
            //book is not allowed to OCR
            this.OCR = this.$t("ocr.notPossibleConvertOcr");
          else {
            try {
              this.OCR = ocr.data.join(" ");
            } catch (ex) {
              console.error("no ocr recieved: ", ocr);
              this.OCR = this.$t("general.noFindResults");
            }
            if (this.OCR.trim() == "")
              this.OCR = this.$t("general.noFindResults");
          }
          let croppedImg;
          clearTimeout(this.timeout);
          this.timeout = setTimeout(async () => {
            croppedImg = await this.drawImgCrop(
              img,
              cWidth,
              cHeight,
              startX,
              startY,
              imgRatio
            );

            //ocr for user book
            if (this.getDrawOcrAction) {
              let payload = {
                rect: { x, y, width, height },
                ocr: this.OCR,
                img: croppedImg,
              };

              this.setOcrOutput(payload);
              this.$store.dispatch("createBook/setOcrAction", false);
              //     this.$store.state.bookPopups.OCRResultsVisible = false;
            }
          }, 500);
        });
      }
    },
    async drawImgCrop(img, cWidth, cHeight, startX, startY, imgRatio) {
      try {
        let bookId = this.getCurrentBook;
        let pageId = this.OCRRect.pageData.name;
        //get image in origin size
        let origImage = await getImageObject(
          bookId,
          pageId,
          "image",
          false,
          {},
          null,
          this.OCRRect.pageData.position
        );
        let origRatio = (origImage.width / img.width) * imgRatio;

        let canvas = this.$refs.canvas;
        if (canvas != undefined) {
          let canvasCtx = canvas.getContext("2d");
          let width;
          let height;
          let canvasWidth = this.$refs.canvasContainer.clientWidth;
          let canvasHeight = this.$refs.canvasContainer.clientHeight;
          canvas.width = canvasWidth;
          canvas.height = canvasHeight;

          if (cWidth > cHeight) {
            width = canvasWidth;
            height = cHeight * (canvasWidth / cWidth);
          } else {
            height = canvasHeight;
            width = cWidth * (canvasHeight / cHeight);
          }

          canvasCtx.clearRect(0, 0, canvasWidth, canvasHeight);

          canvasCtx.drawImage(
            img,
            startX * imgRatio,
            startY * imgRatio,
            cWidth * imgRatio,
            cHeight * imgRatio,
            0,
            0,
            width,
            height
          );
        }
        //this.tempCanvas.setAttribute("dir", "rtl");

        const fontSize = parseInt((cWidth * imgRatio) / 30);

        this.tempCanvas.width = cWidth * origRatio;
        this.tempCanvas.height = cHeight * origRatio + fontSize * 2;
        this.tempCanvasCtx = this.tempCanvas.getContext("2d");
        this.tempCanvasCtx.clearRect(
          0,
          0,
          this.tempCanvas.width,
          this.tempCanvas.height
        );
        this.tempCanvasCtx.fillStyle = "white";
        this.tempCanvasCtx.fillRect(
          0,
          0,
          this.tempCanvas.width,
          this.tempCanvas.height
        );
        this.tempCanvasCtx.drawImage(
          origImage.picture,
          startX * origRatio,
          startY * origRatio,
          cWidth * origRatio,
          cHeight * origRatio,
          0,
          0,
          cWidth * origRatio,
          cHeight * origRatio
        );
        try {
          let footer =
            this.$store.getters[`tabs/${this.tabId}/getBookNameAndAuthor`] +
            " / " +
            this.$t("general.page") +
            " " +
            (this.OCRRect.pageData
              ? this.OCRRect.pageData.letter || this.OCRRect.pageData.position
              : this.OCRRect.pageData.position);

          let footer2 = this.$t(
            `bookPrint.${this.appMode.online() ? "printByWeb" : "printByOtzar"}`
          );

          this.tempCanvasCtx.textAlign = "right";
          this.tempCanvasCtx.fillStyle = "black";
          this.tempCanvasCtx.font = `${fontSize}px David`;
          this.tempCanvasCtx.fillText(
            footer,
            cWidth * origRatio - 10,
            cHeight * origRatio + fontSize
          );
          this.tempCanvasCtx.fillText(
            footer2,
            cWidth * origRatio - 10,
            cHeight * origRatio + fontSize * 2
          );
        } catch (ex) {}
        let dataUrl = this.tempCanvas.toDataURL();

        return dataUrl;
      } catch (ex) {
        console.error(ex);
      }
    },
    copyImageToCB() {
      this.tempCanvas.toBlob(function (blob) {
        const item = new ClipboardItem({ "image/png": blob });
        navigator.clipboard.write([item]);
      });
      const notification = {
        type: "success",
        message: this.$t("bookSelectArea.copyImgMsg"),
        timeout: 4000,
      };
      this.$notify(notification);
    },
    copyImage() {
      this.tempCanvas.toBlob((blob) => {
        let anchor = document.createElement("a");
        anchor.download =
          this.getCurrentBook + "_" + this.OCRRect.pageData.position + ".jpg";
        anchor.href = URL.createObjectURL(blob);
        anchor.click();
        URL.revokeObjectURL(anchor.href);
      }, "image/jpg");
    },
    printCroppedImg() {
      printImage(this.tempCanvas);
    },
    copyTxt() {
      var copyText = this.$refs.textArea;
      copyText.select();
      document.execCommand("copy");
      const notification = {
        type: "success",
        message: this.$t("bookSelectArea.copyTxtMsg"),
        timeout: 4000,
      };
      this.$notify(notification);
    },
    createMarker() {
      let payload = {
        bookId: this.getCurrentBook,
        pageId: this.OCRRect.pageData.id,
        x: this.markerRect.x,
        y: this.markerRect.y,
        width: this.markerRect.width,
        height: this.markerRect.height,
        name: this.OCRRect.pageData.name,
        position: this.OCRRect.pageData.position,
        letter: this.OCRRect.pageData.pagedata[0]?.letter || "",
      };
      //this.$store.dispatch("userPersonalExtensions/addUserMarker", payload);
      this.$store.dispatch(`personalAdditionsTabs/addMarker`, {
        bookId: this.getCurrentBook,
        userMarker: payload,
      });
      //  this.closeResults();
      const notification = {
        type: "success",
        message: this.$t("personalExtensions.succeedMarker"),

        timeout: 2000,
        setting: {
          grid: "icon",
          nameIcon: "marker-small",
          position: "center",
        },
      };
      this.$notify(notification);
      //this.showMarkersList();
    },
    onDragEnd(size) {
      this.setResizeToggle();
      this.toggleSplitter();
    },
    toggleDockable(manual = true, toggle = true, value = true) {
      if (this.$_mobile) {
        if (toggle) {
          this.togglePagesPanel();
        } else {
          this.openDockMobile = value;
          this.setPagesPanel(value);
        }
      } else {
        if (toggle) this.togglePagesPanel();
        else this.setPagesPanel(value);
        this.toggleSplitter();
      }
      if (manual) this.manualToggle = !this.pagesPanelOpen;
    },
    addExtenstions(type) {
      this.closeExtens(); //reset all before start

      this.setOCREnable(type == "marker" || this.ocrMode);

      this.setAddEtensType(type);

      this.startCreateExtentionMode();
    },
    openEditorPosition(e) {
      try {
        if (this.crtExtentionsMode) {
          this.offsetEditor.x = e.offsetX;
          this.offsetEditor.y = e.offsetY;
          if (!this.addingLink || this.addExtensType != "link")
            this.stopCreatModeAllExtantions();
        }
      } catch (ex) {
        console.error(ex);
      }
    },
    closeEditor() {
      this.closeEditorWin();
    },
    pageLetter(page) {
      return page.pagedata &&
        page.pagedata.length > 0 &&
        page.pagedata[0].letter != "" &&
        page.pagedata[0].letter != null
        ? page.pagedata[0].letter.replace(/יה/g, "טו").replace(/יו/g, "טז")
        : page.position;
    },
    goToFSPage(data) {
      this.$store.state.tabsManager.scrollToFsResult = true;
      this.currFsPage = data.id;

      this.goToPage(data);
    },
    getOrigPos(pos) {
      let index = this.getPages
        .filter((p) => !p.empty)
        .findIndex((p) => p.position == pos);

      return index + 1;
    },
    goToPageByOrigPos(pos) {
      let index = this.getPages
        .filter((p) => !p.empty)
        .findIndex((p) => p.position == pos);

      this.goToPage({ page: index + 1 });
    },
    goToPage(pageIndex) {
      if (pageIndex.page == 0) {
        this.$store.state.tabs[this.tabId].showEmptyPage = true;
        return;
      }
      //this.$store.state.tabs[this.tabId].showEmptyPage = false;
      this.go(pageIndex.page, this.tabId); // + 1);
    },

    goToActiveTsiyun(active) {
      if (!this.tsiyunimType1[active]) return;
      this.currentTsiyunItem = active;
      let page = this.tsiyunimType1[this.currentTsiyunItem]; // this.filteredLists.tsiyunim[this.currentTsiyunItem];
      if (page) page = page.position;
      this.goToPage({
        page,
      });
    },
    goToActiveTsiyun2(active) {
      if (!this.tsiyunimType2[active]) return;
      this.currentTsiyunItem2 = active;
      let page = this.tsiyunimType2[this.currentTsiyunItem2]; // this.filteredLists.tsiyunim[this.currentTsiyunItem];
      if (page) page = page.position;
      this.goToPage({
        page,
      });
    },
    goToActiveFSResult(active) {
      this.currentFSItem = active;
      let page = this.getFsResults[this.currentFSItem];
      this.goToFSPage({ page: page.position, id: page.id });
    },
    goToActivePage(active, inc) {
      this.currentPageItem = active;
      let page = this.filteredLists.pages[this.currentPageItem - 1];
      if (page) page = page.position;
      if (page == 0) {
        this.currentPageItem += inc;
        page = this.filteredLists.pages[this.currentPageItem - 1];
        if (page) page = page.position;
      }
      if (page) {
        this.goToPage({
          page,
        });
      }
    },

    goToTsiyun(tsiyunPage) {
      //let page = this.getPages.find(page => page.id == tsiyunPage.page);
      if (tsiyunPage == null) tsiyunPage = 1;
      this.goToPage({ page: tsiyunPage }); //{ page: page.position });
    },
    goToTsiyunByPageName(pageName) {
      this.goToPage({ page: `PID_${pageName}` });
    },
    goToItemPage(item, type = null) {
      if (type === "link" && item.bookId != this.getCurrentBook) {
        return this.openInNewWin(item.bookId, item.position);
      }
      let page;
      if (type == "lastpage") {
        //stupid fix
        item = { ...item };
        item.page = item.pageId;
        delete item.pageId;
      }

      //stupid fix
      if (item.pageId)
        page = this.getPages.find((page) => page.id == item.pageId);
      else page = this.getPages.find((page) => page.position == item.page);
      if (!page) {
        page = this.getPages.find((page) => page.position == item.position);
      }
      if (!page) return;
      this.go(page.position, this.tabId);
    },
    searchInList(index) {
      this.searchTxt[index] = event.target.value;
    },
    searchInListClear(index) {
      this.searchTxt[index] = "";
    },
    changeDock() {
      this.dock = this.dock == "dock" ? "float" : "dock";
    },
    setPersonalAdditionsPanelOpen(mode) {
      this.$store.state.tabs[this.tabId].personalAdditionsPanelOpen = mode;
    },
    setNavigatePartsOpen(payload) {
      this.$store.state.tabs[this.tabId].navigatePartsOpen = payload;
    },

    setRecentsPagesOpen(val) {
      this.react++;
      localStorage.setItem("recPages", val);
    },

    setPartOpen(index, open) {
      if (index == 5 || open == 5) {
        if (this.getRecentPages.length > 0) {
          //this.openREcent = false;
        }

        this.openRecentAnyway = !this.openRecentAnyway;
        this.setRecentsPagesOpen(this.openRecentAnyway);
      }
      if (!open && this.navigatePartsOpen.filter((elem) => elem).length <= 1)
        open = true;
      this.navigatePartsOpen.splice(index, 1, open);
      this.setNavigatePartsOpen(this.navigatePartsOpen);
    },
    setPartOpen1(index, open) {
      if (open) this.extensOpenIndex = index;
      else this.extensOpenIndex = index == 1 ? 4 : index + 1;
    },
    openStatus(index) {
      return this.navigatePartsOpen[index];
    },
    showDetailsWin() {
      // this.showDetails = show;
      this.$store.dispatch(
        "bookPopups/showBookDetailsVisible",
        this.getCurrentBook
      );
    },
    closeDetails() {
      this.showDetails = false;
      this.$store.dispatch("bookPopups/toggleBookDetailsVisible");
    },
    showPrintWin(payLoad) {
      this.fitSizePrintWin(false);
      this.printFrom = payLoad.from || -1;
      this.printTo = payLoad.to || -1;

      this.showPrint = payLoad.show;
    },
    closePrintWin() {
      //  this.loading = false;
      // this.$emit("loading", false);
      stopPrinting();
      //this.$emit("close");
      this.$socket.client.emit("printCancel", this.printId);
      this.showPrint = false;
    },
    clear(input, index) {
      input.value = "";
      this.searchInListClear(index);
    },
    openMareMakom(catBook, catPage, CpageName) {
      if (!catPage || !catBook) return;
      let page = CpageName != undefined ? "PID_" + CpageName : "P" + catPage;
      this.openInNewWin(catBook, page, null, null);
    },
    changeFontFamily(font) {
      this.fontF = font;
    },
    changeFontSize(size) {
      this.fontS = size;
    },
    togglePin() {
      this.hasPin = !this.hasPin;
      this.$store.dispatch(`tabs/${this.tabId}/triggerResize`, null, {
        root: true,
      });
      this.setPersonalAdditionsPanelOpen(this.hasPin ? "dock" : "float");
    },
    /*  down(event) {
      event.stopPropagation();

      event.preventDefault();

      let part = 0;
      let list = [];
      switch (part) {
        case 0:
          list = this.filteredLists.pages;
          break;
        case 1:
          list = this.filteredLists.tsiyunim;
          break;
        case 2:
          list = this.filteredLists.usertsiyuim;
          break;
        case 3:
          list = this.getFsResults;
          break;
      }
      if (this.activeItem[part] < list.length) {
        this.activeItem[part]++;
        let page = list[this.activeItem[part]];
        this.goToPage({ page: page.position });
      }
    },
    up(event) {
      event.stopPropagation();

      event.preventDefault();
      let part = 0;
      if (this.activeItem[part] > 1) this.activeItem[part]--;
    }, */
    closeUserExtens() {
      this.closeExtens();
      this.showUserAdditionsWin = false;
    },
    fitSizePrintWin(flag) {
      if (flag) {
        this.hPrint = 220;
      } else this.hPrint = this.appMode.online() ? 650 : 480;
    },
    keyEventHandler(event) {
      if (event.ctrlKey && "oOם".indexOf(event.key) !== -1) {
        event.preventDefault();
        this.toggleDockable();
      }
    },
  },
  beforeDestroy() {
    this.interval = clearInterval(this.interval);
    this.timeout = clearTimeout(this.timeout);
    document.body.removeEventListener("keydown", this.keyEventHandler);
  },
  created() {
    this.navigatePartsOpen = this.getNavigatePartsOpen;
  },
  mounted() {
    document.body.addEventListener("keydown", this.keyEventHandler);

    this.openRecentAnyway = this.getRecentsPagesOpen;
    this.tempCanvas = document.createElement("canvas");
    this.tempCanvasCtx = this.tempCanvas.getContext("2d");

    if (this.$_mobile) {
      this.openDockMobile = false;
    }

    if (
      this.fullScreen &&
      this.userSettings.settings.full_screen_hide_right_bar == 1
    )
      this.toggleDockable(false, false, false);
    this.$nextTick(() => {
      this.toggleSplitter();
    });

    //manage PersonalAdditionsPanelOpen from _tab
    if (this.personalAdditionsPanelOpen) {
      this.hasPin = this.personalAdditionsPanelOpen === "dock";
      this.showUserAdditionsWin = true;
    }
    //manage open new comment
    let tempComment = this.$store.state.tabs[this.tabId].newComment;
    if (tempComment?.data && !tempComment?.edit) {
      if (tempComment.item?.bookId == this.getBook) {
        this.setAddEtensType("comment");
        this.showEditor = true;
      }
    } else {
      //manage open new key
      let tempKey = this.$store.state.tabs[this.tabId].newKey;
      if (tempKey?.data && !tempKey?.edit) {
        if (tempKey.item?.bookId == this.getBook) {
          this.setAddEtensType("key");
          this.showEditor = true;
        }
      }
    }
    this.showMefFeuthures = this.startWithMefo;
  },
};

function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

function smartSearch(text, query) {
  const words = query.trim().split(/\s+/);
  let index = 0;

  for (const word of words) {
    index = text.indexOf(word, index);
    if (index === -1) return false;
  }
  return true;
}
</script>
<style lang="scss">
.truncate-txt {
  white-space: nowrap; /* Prevent text from wrapping to a new line */
  overflow: hidden; /* Hide any text that overflows the container */
  text-overflow: ellipsis; /* Add the ellipsis when text is truncated */
  width: 100%; /* Ensure the width of the element is defined */
  display: block; /* Ensures the element is treated as a block for proper width application */
}
.textSizeBtn {
  line-height: 20px !important;
  height: 20px !important;
}
.book {
  flex-grow: 1;
  display: flex;
  height: 100%;
}
.hide {
  display: none !important;
}
.header-book-area {
  border-bottom: 1px solid rgb(212, 212, 212);
  height: 33px;
  display: flex;
  justify-content: space-between;
  padding-right: 15px;
  align-items: center;
}
.nav-active {
  background-color: #dbdbdb !important;
}
.nav-visited {
  // border-right: 3px solid var(--custom-color2);
}
.nav-visited::before {
  content: "";
  border-top: 7px solid transparent;
  border-right: 7px solid var(--custom-color2);
  border-bottom: 7px solid transparent;
  width: 0px;
  max-height: 0px;
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
  // opacity: 0.8;
}

.close .gutter.gutter-horizontal {
  display: none;
}
.book-details {
  background-color: white;
  font-size: 12px;
  width: 450px !important;
  height: 417px !important;
  left: 10px;
  top: 10px;
  // border: 1px solid #00000059;
  // -webkit-box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.16);
  // box-shadow: 3px 3px 11px rgba(0, 0, 0, 0.46);
}
.list-header {
  display: flex;
  flex-direction: column;
}
.bookBox {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: relative;
}
.div-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  // transform: rotate(90deg);
  transition: 0.3s;
}
.print-book {
  background-color: white;
  font-size: 12px;
  // width: 440px !important;
  // height: 400px !important;
  left: 10px;
  top: 10px;
  // border: #f1f1f1 1px solid;
  // box-shadow: 0 2px 5px 2px #0000005c;
  &.loading {
    // height: fit-content !important;
  }
}
.mobilecenter {
  justify-content: center;
  padding-right: 0px;
}
.dock {
  position: relative !important;
  top: auto !important;
  left: auto !important;
  height: 100% !important;
  overflow: auto;
  width: 220px !important;
  z-index: 1 !important;
}
.dock.extensions-dock {
  width: 263px !important;
}
.extensions-dock.pinned {
  .icon-pin {
    color: var(--custom-color1) !important;
  }
}
.extensions-dock.pinned {
  transform: translate(0px, 0px) !important;
  position: relative !important;
  height: calc(100% - 25px) !important;
  box-shadow: none;
  border-right: 1px solid #b2b2b2;
  .icon-pin {
    &::before {
      content: "/";
      position: absolute;
      transform: rotate(-50deg);
      left: 4px;
      top: -1px;
    }
  }
}
.float1 {
  position: absolute;
  top: 4px;
  left: 4px;
  height: calc(100% - 75px) !important;
  // overflow: auto;
  width: 186px !important;
  // border: solid 1px black;
  z-index: 5 !important;
  background-color: white;
  box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.16);
  box-shadow: 2px 3px 3px 1px #00000040;
}
.open-book-btn {
  position: absolute;
  left: 0px;
  bottom: 0px;
  margin-left: 60px;
  margin-bottom: 20px;
  display: none;
}
.flex-wrap {
  display: flex !important;
  flex-wrap: wrap !important;
}
.fullScreen {
  width: 100%;
}
.open-dockable {
  display: flex;
  position: relative;
  flex-grow: 1;
  // width: 0;
  // min-width: 150px;
  overflow: hidden;
  // transition: width 0.3s;
  &.close {
    display: none;
  }
  .container {
    width: 100%;
    overflow: hidden;
    transition: 0.3s;
  }
  .open {
    width: 100%;
  }
  .icon-close-dockable {
    color: rgba(0, 0, 0, 0.46);
    height: 30px;
    line-height: 30px;
    // position: absolute;
    // left: 0;
    font-size: 17px;
    padding: 0 3px;
    // border-right: 1px solid rgba(0, 0, 0, 0.1);
    border-left: 1px solid rgba(0, 0, 0, 0.1);
  }
}
.mobile-close-dock-container {
  width: 100%;
  position: absolute;
}
.mobile-button-location {
  left: -25px;
  right: unset !important;
}
.always-show-book {
  display: flex !important;
}
.icon-close-dockable.otz-icon {
  position: absolute;
  height: 32px;
  top: 0;
  -webkit-box-shadow: 0 1px 3px #00000066;
  box-shadow: 0 1px 3px #00000066;
  z-index: 1;
  font-size: 30px;
  line-height: 32px;
  border-radius: 50% 0 0 50%;
  border-radius: 15px 0 0 15px;
  // background-color: var(--custom-color1);
  // background-color: #0000001f;

  border-right: 0;
  background-color: #e4e2e2;
  color: var(--custom-color2);
  right: -2px;
  width: 23px;
  font-size: 18px;
  transition: 0.3s;
  &:hover {
    // text-align: right;
    background-color: var(--custom-color1) !important;
    color: #fff;
    width: 21.5px;
  }
}
.mobile-book-info {
  position: absolute;
  z-index: 100;
  border-left: 3px #d41d1d;
  background-color: white;
}
.icon-open-dockable.otz-icon.fullscreen {
  right: 15px !important;
  z-index: 999;
  &:hover {
    width: 37px !important;
    right: 16px !important;
  }
}
.icon-open-dockable.otz-icon {
  position: absolute;
  height: 35px !important;
  top: 0;
  -webkit-box-shadow: 0 1px 3px #00000066;
  box-shadow: 0 1px 3px #00000066;
  z-index: 1;
  font-size: 30px;
  line-height: 35px;
  border-radius: 50% 0 0 50%;
  border-radius: 23px 0 0 23px;
  border-right: 0;
  right: -2px;
  height: 30px;
  width: 34px;
  font-size: 36px;
  text-align: right;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  background-color: var(--custom-color1);
  color: #fff;
  .inner-icon {
    font-size: 36px;
    color: #fff;
    width: 20px !important;
    display: block;
    line-height: 35px;
    margin-right: -3px;
    background-color: transparent !important;
  }
  &:hover {
    width: 37px;
    right: -1px;
  }
  // ***
  background-color: var(--custom-color1);
  color: #fff;
  &:hover {
    // background-color: #81592a;
    background-color: var(--custom-color1) !important;
    box-shadow: 0 3px 4px #00000066;
  }
}
.tsiyunim-close {
  .gutter {
    display: none;
  }
}
.clear-input.otz-icon {
  position: absolute;
  left: 6px;
  top: 5px;
  font-size: 9px;
}
.seperator {
  width: 100%;
  height: 2px;
  background-color: rgba(0, 0, 0, 0.2);
}
.mobile-book-info-w {
  max-width: 200px;
  position: absolute;
  height: 100%;
  right: 0px;
  z-index: 100;
  overflow: visible;
  background-color: white;
  border-left: 2px solid #dedede;
  margin-top: -7px;
}
.ocr-win-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.ocr-content {
  height: 90%;
}
.title-ocr-win {
  position: absolute;
  top: 3px;
  color: gray;
  font-weight: bold;
  color: #b2b2b2;
  font-size: 12px;
}
.mobile-book {
  width: 100%;
}
.recent-container {
  overflow-x: hidden;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding-top: 3px;
}
</style>
